import { render, staticRenderFns } from "./IcoBuilding3.vue?vue&type=template&id=377af48e"
import script from "./IcoBuilding3.vue?vue&type=script&lang=js"
export * from "./IcoBuilding3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports